export default __webpack_public_path__ + "6d53527cf9d1495646f1d13dbed73d07.png";